import Vue from 'vue';

import Vuebar from 'vuebar';

import SoundsPlugin from '../core/sounds/plugin';
Vue.use(SoundsPlugin);

import VueVKeyboard from 'vue-vkeyboard';
import layouts from '../config/keyboard-layouts';

import {
  LinkStyle,
  CtaStyle,
  PillStyle,
  ArrowStyle,
  InputStyle,
  HoverStyle,
  IconGlowStyle,
  ClearStyle,
} from '@/launcher/components/shared/styled';
import {
  PillToggle,
  ArrowButton,
} from '@/launcher/components/shared/styled-ui';
import {
  GridContainer,
  ScrollElement,
} from '@/launcher/components/shared/ui';
import LauncherRouterLink from '@/launcher/components/shared/system/LauncherRouterLink';
import FunctionalBinder from '@/launcher/components/shared/system/FunctionalBinder';
import Animator from '@/launcher/components/shared/system/Animator';
import { mergeData } from 'vue-functional-data-merge';

// const withSounds = (Component) => ({
//   functional: true,
//   render (h, ctx) {
//     return h(Component, {
//       directives: [
//         {
//           name: 'sound',
//           value: 'click',
//         },
//       ],
//       ...ctx.data,
//     }, ctx.children)
//   },
// })

Vue.config.productionTip = false;
Vue.use(Vuebar);
Vue.use(VueVKeyboard, { layouts });

Vue.component('cta-style', CtaStyle);
Vue.component('clear-style', ClearStyle);
Vue.component('link-style', LinkStyle);
Vue.component('pill-style', PillStyle);
Vue.component('arrow-style', ArrowStyle);
// Vue.component('link-style', withSounds(LinkStyle))
// Vue.component('pill-style', withSounds(PillStyle))
// Vue.component('arrow-style', withSounds(ArrowStyle))
Vue.component('input-style', InputStyle);
Vue.component('hover-style', HoverStyle);
Vue.component('icon-glow-style', IconGlowStyle);

Vue.component('pill-toggle', PillToggle);
Vue.component('arrow-button', ArrowButton);

Vue.component('grid-container', GridContainer);
Vue.component('scroll-element', ScrollElement);

Vue.component('launcher-router-link', LauncherRouterLink);
Vue.component('functional-binder', FunctionalBinder);
Vue.component('animator', Animator);
Vue.component('icon', {
  functional: true,
  props: {
    name: { required: true },
  },
  render (h, { props, data }) {
    return h('svg', mergeData(
      data,
      {
        staticClass: 'icon',
        class: `icon-station-${props.name}`,
        attrs: {
          viewBox: '0 0 100 100',
          ...data.attrs,
        },
      },
    ), [
      h('use', {
        attrs: {
          'xlink:href': `#icon-station-${props.name}`,
        },
      }),
    ]);
  },
});
